import {
  NETWORK_ACCESS_DENIED,
  NETWORK_CONFLICT,
  NETWORK_SERVER_ERROR,
  NETWORK_UNAUTHORIZED,
  NETWORK_DEFAULT_ERROR,
  RESET_NETWORK_ERROR,
  RESET_NETWORK_ERRORS,
  NETWORK_BAD_REQUEST,
  CUSTOM_ERROR,
} from '../constants/ActionTypes';
import {
  unauthorized,
  accessDenied,
  serverError,
  defaultError,
  conflictError,
  badRequest,
} from '../constants/NetworkErrors';

// TODO: refactor, reduce code

export default function network(
  state = {
    errors: [],
  },
  action
) {
  switch (action.type) {
    case NETWORK_UNAUTHORIZED:
      return {
        ...state,
        errors: [...state.errors, unauthorized],
      };
    case NETWORK_ACCESS_DENIED:
      return {
        ...state,
        errors: [...state.errors, accessDenied],
      };
    case NETWORK_CONFLICT:
      return {
        ...state,
        errors: [...state.errors, conflictError],
      };
    case NETWORK_SERVER_ERROR:
      return {
        ...state,
        errors: [...state.errors, serverError],
      };
    case NETWORK_DEFAULT_ERROR:
      return {
        ...state,
        errors: [...state.errors, defaultError],
      };
    case NETWORK_BAD_REQUEST:
      return {
        ...state,
        errors: [...state.errors, badRequest],
      };
    case CUSTOM_ERROR:
      return {
        ...state,
        errors: [...state.errors, action.error],
      };
    case RESET_NETWORK_ERROR:
      return {
        ...state,
        errors: state.errors.filter((error) => error !== action.error),
      };
    case RESET_NETWORK_ERRORS:
      return {
        ...state,
        errors: [],
      };
    default:
      return state;
  }
}
